<div class="container">

  <div class="avatarwrap" style="height: calc(100vh - 0px);">
    <div class="mb-2">
      <div class="topNavH"></div>
      <div class="text-end mb-3">
        <app-settings-offcanvas></app-settings-offcanvas>
      </div>
    </div>

    <div class="scroll-box">
      <h3 class="bigTitleCol">{{ 'ADD_STUDENT.PAGE_TITLE' | translate }}</h3>
      <p>{{ 'ADD_STUDENT.PAGE_INFO' | translate }}</p>
      <form #studentProfileForm="ngForm" (ngSubmit)="submitProfile()" novalidate id="studentDataForm">
        <div class="accordion mb-3" id="personalInfoAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingPersonal">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapsePersonal" aria-expanded="true" aria-controls="collapsePersonal">
                {{ 'ADD_STUDENT.PART_A.ACCORDION_TITLE' | translate }}
              </button>
            </h2>
            <div id="collapsePersonal" class="accordion-collapse collapse show" aria-labelledby="headingPersonal"
              data-bs-parent="#personalInfoAccordion">
              <div class="accordion-body">
                <div class="mb-3">
                  <label class="form-label"><span class="text-danger">*</span>{{ 'ADD_STUDENT.PART_A.PHOTO_LABEL' |
                    translate }}</label>
                  <div *ngIf="hasPhotoError && studentProfileForm.submitted" class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PHOTO_REQUIRED' | translate }}
                  </div>
                  <input type="file" class="d-none" id="photoFileActual" name="photo" required
                    (change)="onFileSelected($event)" #photoFileActual accept="image/*">
                  <div class="parent-container">
                    <label for="photoFileActual" class="custom-file-upload-area">
                      <div *ngIf="!imagePreviewUrl" class="upload-placeholder">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
                          class="bi bi-camera-fill mb-2 text-muted" viewBox="0 0 16 16">
                          <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                          <path
                            d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828-.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0" />
                        </svg>
                        <p class="text-muted">{{ 'ADD_STUDENT.PART_A.CLICK_TO_UPLOAD' | translate }}</p>
                        <p class="small text-muted">{{ 'ADD_STUDENT.PART_A.Image_formats' | translate }}</p>
                      </div>

                      <img *ngIf="imagePreviewUrl" [src]="imagePreviewUrl"
                        alt="{{ 'ADD_STUDENT.PART_A.IMAGE_PREVIEW_ALT' | translate }}" class="image-preview">
                    </label>

                  </div>

                </div>

                <div class="mb-3">
                  <label for="chi_name" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.NAME_ZH_LABEL' | translate }}</label>
                  <input type="text" class="form-control" id="chi_name" ngModel name="chi_name" required>
                  <div
                    *ngIf="studentProfileForm.controls['chi_name']?.errors?.['required'] && studentProfileForm.controls['chi_name']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.CHI_NAME_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="eng_name" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.NAME_EN_LABEL' | translate }}</label>
                  <input type="text" class="form-control" id="eng_name" ngModel name="eng_name" required>
                  <div
                    *ngIf="studentProfileForm.controls['eng_name']?.errors?.['required'] && studentProfileForm.controls['eng_name']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.ENG_NAME_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="other_name" class="form-label">{{ 'ADD_STUDENT.PART_A.ALIAS_LABEL' | translate }}</label>
                  <input type="text" class="form-control" id="other_name" ngModel name="other_name">
                </div>
                <div class="mb-3">
                  <label for="birth" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.BIRTH_DATE_LABEL' | translate
                    }}</label>
                  <input type="date" class="form-control" id="birth" ngModel name="birth" required
                    (change)="calculateAge($event)">
                  <div
                    *ngIf="studentProfileForm.controls['birth']?.errors?.['required'] && studentProfileForm.controls['birth']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.BIRTH_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="form-check mb-3">
                  <input class="form-check-input" type="checkbox" id="ageDisclaimer" name="ageDisclaimer" ngModel
                    required>
                  <label class="form-check-label" for="ageDisclaimer">
                    <span class="text-danger">*</span> {{ 'ADD_STUDENT.PART_A.AGE_DISCLAIMER_LABEL' | translate }}
                  </label>
                  <div
                    *ngIf="studentProfileForm.controls['ageDisclaimer']?.errors?.['required'] && studentProfileForm.controls['ageDisclaimer']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.AGE_DISCLAIMER_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="nationality" class="form-label"><span class="text-danger">*</span>{{
                      'ADD_STUDENT.PART_A.NATIONALITY_LABEL' | translate
                      }}</label>
                  <select class="form-select" id="nationality" name="nationality" ngModel required>
                      <option *ngFor="let nat of nationalities" [value]="nat">
                          {{ 'NATIONALITIES.' + nat | translate }}
                      </option>
                  </select>
                  <div *ngIf="studentProfileForm.controls['nationality']?.errors?.['required'] && studentProfileForm.controls['nationality']?.touched"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.NATIONALITY_REQUIRED' | translate }}
                  </div>
              
                  <div *ngIf="studentProfileForm.value.nationality === 'OTHER'" class="mt-2"><span class="text-danger">*</span>
                      <label for="other_nationality" class="form-label small">{{ 'ADD_STUDENT.PART_B.SPECIFY_LABEL' | translate }}</label>
                      <input type="text" class="form-control form-control-sm" id="other_nationality" name="other_nationality" required ngModel>
                  </div>
              </div>
                <!-- <div class="col-md-6 mb-3 mb-md-0 ">
                  <label for="nationality" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.NATIONALITY_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="nationality" ngModel name="nationality" required>
                  <div
                    *ngIf="studentProfileForm.controls['nationality']?.errors?.['required'] && studentProfileForm.controls['nationality']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.NATIONALITY_REQUIRED' | translate }}
                  </div>
                </div> -->
                <div class="mb-3 d-flex mt-3">
                  <label class="form-label"><span class="text-danger">*</span>{{ 'ADD_STUDENT.PART_A.GENDER_LABEL' |
                    translate }}：</label>
                  <div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="genderM" value="Male" ngModel name="gender"
                        required>
                      <label class="form-check-label" for="genderM">{{ 'ADD_STUDENT.PART_A.GENDER_OPTION_MALE' |
                        translate
                        }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="genderF" value="Female" ngModel name="gender"
                        required>
                      <label class="form-check-label" for="genderF">{{ 'ADD_STUDENT.PART_A.GENDER_OPTION_FEMALE' |
                        translate
                        }}</label>
                    </div>
                    <div
                      *ngIf="studentProfileForm.controls['gender']?.errors?.['required'] && studentProfileForm.controls['gender']?.touched"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.GENDER_REQUIRED' | translate }}
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_B.STUDENT_EMAIL_LABEL' | translate
                    }}</label>
                  <input type="email" class="form-control" id="email" ngModel name="email" required>
                  <div
                    *ngIf="studentProfileForm.controls['email']?.errors?.['required'] && studentProfileForm.controls['email']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.STUDENT_EMAIL_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="mb-3 inputlabelWith">
                    <label for="age" class="form-label"><span class="text-danger">*</span>{{
                      'ADD_STUDENT.PART_A.AGE_LABEL' | translate }}</label>
                    <div class="input-group">
                      <input type="number" class="form-control" id="age" ngModel name="age" required>
                      <span class="input-group-text">{{ 'ADD_STUDENT.PART_A.AGE_UNIT' | translate }}</span>
                    </div>
                    <div
                      *ngIf="studentProfileForm.controls['age']?.errors?.['required'] && studentProfileForm.controls['age']?.touched"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.AGE_REQUIRED' | translate }}
                    </div>
                  </div>
                  <div class="col-md-6 inputlabelWith">
                    <label for="weight" class="form-label"><span class="text-danger">*</span>{{
                      'ADD_STUDENT.PART_A.WEIGHT_LABEL' | translate }}</label>
                    <div class="input-group">
                      <input type="number" class="form-control" id="weight" ngModel name="weight" required>
                      <span class="input-group-text">kg</span>
                    </div>
                    <div
                      *ngIf="studentProfileForm.controls['weight']?.errors?.['required'] && studentProfileForm.controls['weight']?.touched"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.WEIGHT_REQUIRED' | translate }}
                    </div>
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="col-md-6 mb-3 mb-md-0 inputlabelWith">
                    <label for="height" class="form-label"><span class="text-danger">*</span>{{
                      'ADD_STUDENT.PART_A.HEIGHT_LABEL' | translate }}</label>
                    <div class="input-group">
                      <input type="number" class="form-control" id="height" ngModel name="height" required>
                      <span class="input-group-text">cm</span>
                    </div>
                    <div
                      *ngIf="studentProfileForm.controls['height']?.errors?.['required'] && studentProfileForm.controls['height']?.touched"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.HEIGHT_REQUIRED' | translate }}
                    </div>
                  </div>
                  <div class="col-md-6 inputlabelWith">
                    <label for="head_size" class="form-label"><span class="text-danger">*</span>{{
                      'ADD_STUDENT.PART_A.HEAD_CIRCUMFERENCE_LABEL' |
                      translate }}</label>
                    <div class="input-group">
                      <input type="number" class="form-control" id="head_size" ngModel name="head_size" required>
                      <span class="input-group-text">cm</span>
                    </div>
                    <div
                      *ngIf="studentProfileForm.controls['head_size']?.errors?.['required'] && studentProfileForm.controls['head_size']?.touched"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.HEAD_SIZE_REQUIRED' | translate }}
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="diagnosis" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.DIAGNOSIS_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="diagnosis" ngModel name="diagnosis" required>
                  <div
                    *ngIf="studentProfileForm.controls['diagnosis']?.errors?.['required'] && studentProfileForm.controls['diagnosis']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.DIAGNOSIS_REQUIRED' | translate }}
                  </div>
                </div>
                <hr>
                <p class="fw-bold">{{ 'ADD_STUDENT.PART_A.GUARDIAN_INFO_TITLE' | translate }}</p>
                <div class="mb-3">
                  <label for="parent_name" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.GUARDIAN_NAME_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="parent_name" ngModel name="parent_name" required>
                  <div
                    *ngIf="studentProfileForm.controls['parent_name']?.errors?.['required'] && studentProfileForm.controls['parent_name']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PARENT_NAME_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="parent_relationship" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.RELATIONSHIP_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="parent_relationship" ngModel name="parent_relationship"
                    required>
                  <div
                    *ngIf="studentProfileForm.controls['parent_relationship']?.errors?.['required'] && studentProfileForm.controls['parent_relationship']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PARENT_RELATIONSHIP_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="parent_mobile" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.MOBILE_NO_LABEL' | translate
                    }}</label>
                  <input type="tel" class="form-control" id="parent_mobile" ngModel name="parent_mobile" required>
                  <div
                    *ngIf="studentProfileForm.controls['parent_mobile']?.errors?.['required'] && studentProfileForm.controls['parent_mobile']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PARENT_MOBILE_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="parent_email" class="form-label"><span class="text-danger">*</span>{{ 'ADD_STUDENT.PART_A.EMAIL_LABEL' | translate }}</label>
                  <input type="email" class="form-control" id="parent_email" ngModel name="parent_email" required>
                  <div
                    *ngIf="studentProfileForm.controls['parent_email']?.errors?.['required'] && studentProfileForm.controls['parent_email']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PARENT_EMAIL_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="parent_home" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.HOME_NO_LABEL' | translate }}</label>
                  <input type="tel" class="form-control" id="parent_home" ngModel name="parent_home" required>
                  <div
                    *ngIf="studentProfileForm.controls['parent_home']?.errors?.['required'] && studentProfileForm.controls['parent_home']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PARENT_HOME_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="parent_address" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.CORRESPONDENCE_ADDRESS_LABEL' | translate }}</label>
                  <textarea class="form-control" id="parent_address" rows="3" ngModel name="parent_address"
                    required></textarea>
                  <div
                    *ngIf="studentProfileForm.controls['parent_address']?.errors?.['required'] && studentProfileForm.controls['parent_address']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PARENT_ADDRESS_REQUIRED' | translate }}
                  </div>
                </div>
                <hr>
                <p class="fw-bold">{{ 'ADD_STUDENT.PART_A.EMERGENCY_CONTACT_TITLE' | translate }}</p>
                <div class="mb-3">
                  <label for="emergency_person" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.EMERGENCY_CONTACT_PERSON_LABEL' | translate }}</label>
                  <input type="text" class="form-control" id="emergency_person" ngModel name="emergency_person"
                    required>
                  <div
                    *ngIf="studentProfileForm.controls['emergency_person']?.errors?.['required'] && studentProfileForm.controls['emergency_person']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.EMERGENCY_PERSON_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="emergency_mobile" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.EMERGENCY_MOBILE_NO_LABEL' |
                    translate }}</label>
                  <input type="tel" class="form-control" id="emergency_mobile" ngModel name="emergency_mobile" required>
                  <div
                    *ngIf="studentProfileForm.controls['emergency_mobile']?.errors?.['required'] && studentProfileForm.controls['emergency_mobile']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.EMERGENCY_MOBILE_REQUIRED' | translate }}
                  </div>
                </div>
                <hr>
                <p class="fw-bold">{{ 'ADD_STUDENT.PART_A.OTHER_INFO_TITLE' | translate }}</p>
                <div class="mb-3">
                  <label for="other_therapy" class="form-label">{{
                    'ADD_STUDENT.PART_A.OTHER_THERAPY_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="other_therapy" ngModel name="other_therapy">
                  <div
                    *ngIf="studentProfileForm.controls['other_therapy']?.errors?.['required'] && studentProfileForm.controls['other_therapy']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.OTHER_THERAPY_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="medication" class="form-label">{{
                    'ADD_STUDENT.PART_A.MEDICATION_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="medication" ngModel name="medication">
                  <div
                    *ngIf="studentProfileForm.controls['medication']?.errors?.['required'] && studentProfileForm.controls['medication']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.MEDICATION_REQUIRED' | translate }}
                  </div>
                </div>
                <hr>
                <p class="fw-bold">{{ 'ADD_STUDENT.PART_A.SCHOOL_INFO_TITLE' | translate }}</p>
                <div class="mb-3">
                  <label for="school_name" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.SCHOOL_NAME_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="school_name" ngModel name="school_name" required>
                  <div
                    *ngIf="studentProfileForm.controls['school_name']?.errors?.['required'] && studentProfileForm.controls['school_name']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.SCHOOL_NAME_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="school_address" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.SCHOOL_ADDRESS_LABEL' | translate
                    }}</label>
                  <textarea class="form-control" id="school_address" rows="3" ngModel name="school_address"
                    required></textarea>
                  <div
                    *ngIf="studentProfileForm.controls['school_address']?.errors?.['required'] && studentProfileForm.controls['school_address']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.SCHOOL_ADDRESS_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="school_contact_person" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.SCHOOL_CONTACT_PERSON_LABEL' |
                    translate }}</label>
                  <input type="text" class="form-control" id="school_contact_person" ngModel
                    name="school_contact_person" required>
                  <div
                    *ngIf="studentProfileForm.controls['school_contact_person']?.errors?.['required'] && studentProfileForm.controls['school_contact_person']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.SCHOOL_CONTACT_PERSON_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="school_tel" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.SCHOOL_TELEPHONE_LABEL' |
                    translate
                    }}</label>
                  <input type="tel" class="form-control" id="school_tel" ngModel name="school_tel" required>
                  <div
                    *ngIf="studentProfileForm.controls['school_tel']?.errors?.['required'] && studentProfileForm.controls['school_tel']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.SCHOOL_TEL_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="school_fax" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.SCHOOL_FAX_LABEL' | translate
                    }}</label>
                  <input type="tel" class="form-control" id="school_fax" ngModel name="school_fax" required>
                  <div
                    *ngIf="studentProfileForm.controls['school_fax']?.errors?.['required'] && studentProfileForm.controls['school_fax']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.SCHOOL_FAX_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="school_email" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_A.SCHOOL_EMAIL_LABEL' | translate
                    }}</label>
                  <input type="email" class="form-control" id="school_email" ngModel name="school_email" required>
                  <div
                    *ngIf="studentProfileForm.controls['school_email']?.errors?.['required'] && studentProfileForm.controls['school_email']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.SCHOOL_FAX_REQUIRED' | translate }}
                  </div>
                </div>
                <hr>
                <p class="fw-bold">{{ 'ADD_STUDENT.PART_A.RIDING_EXPERIENCE_TITLE' | translate }}</p>
                <div class="mb-3">
                  <label for="riding_experience" class="form-label">{{
                    'ADD_STUDENT.PART_A.RIDING_EXPERIENCE_LABEL' |
                    translate }}</label>
                  <textarea class="form-control" id="riding_experience" rows="3" ngModel
                    name="riding_experience"></textarea>
                  <div
                    *ngIf="studentProfileForm.controls['riding_experience']?.errors?.['required'] && studentProfileForm.controls['riding_experience']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.RIDING_EXPERIENCE_REQUIRED' | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion mb-3" id="assessmentAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingAssessment">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseAssessment" aria-expanded="true" aria-controls="collapseAssessment">
                {{ 'ADD_STUDENT.PART_B.ACCORDION_TITLE' | translate }}
              </button>
            </h2>
            <div id="collapseAssessment" class="accordion-collapse collapse show" aria-labelledby="headingAssessment"
              data-bs-parent="#assessmentAccordion">
              <div class="accordion-body">
                <p>{{ 'ADD_STUDENT.PART_B.ASSESSOR_INSTRUCTION' | translate }}</p>
                <div class="mb-3">
                  <label for="assessor_name" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_B.ASSESSOR_NAME_LABEL' | translate
                    }}</label>
                  <input type="text" class="form-control" id="assessor_name" ngModel name="assessor_name" required>
                  <div
                    *ngIf="studentProfileForm.controls['assessor_name']?.errors?.['required'] && studentProfileForm.controls['assessor_name']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.ASSESSOR_NAME_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="assessor_profession" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_B.ASSESSOR_PROFESSION_LABEL' |
                    translate }}</label>
                  <input type="text" class="form-control" id="assessor_profession" ngModel name="assessor_profession"
                    required>
                  <div
                    *ngIf="studentProfileForm.controls['assessor_profession']?.errors?.['required'] && studentProfileForm.controls['assessor_profession']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.ASSESSOR_PROFESSION_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="assessor_tel" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_B.ASSESSOR_TELEPHONE_LABEL' |
                    translate }}</label>
                  <input type="tel" class="form-control" id="assessor_tel" ngModel name="assessor_tel" required>
                  <div
                    *ngIf="studentProfileForm.controls['assessor_tel']?.errors?.['required'] && studentProfileForm.controls['assessor_tel']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.ASSESSOR_TEL_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="assessment_date" class="form-label"><span class="text-danger">*</span>{{
                    'ADD_STUDENT.PART_B.ASSESSMENT_DATE_LABEL' | translate
                    }}</label>
                  <input type="date" class="form-control" id="assessment_date" ngModel name="assessment_date" required>
                  <div
                    *ngIf="studentProfileForm.controls['assessment_date']?.errors?.['required'] && studentProfileForm.controls['assessment_date']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.ASSESSMENT_DATE_REQUIRED' | translate }}
                  </div>
                </div>
                <div class="mb-3">
                  <label for="assessorEmail" class="form-label">{{
                    'ADD_STUDENT.PART_B.ASSESSOR_EMAIL_LABEL' | translate
                    }}</label>
                  <input type="email" class="form-control" id="assessorEmail" ngModel name="assessor_email" >
                  <div
                    *ngIf="studentProfileForm.controls['assessor_email']?.errors?.['required'] && studentProfileForm.controls['assessor_email']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.ASSESSOR_EMAIL_REQUIRED' | translate }}
                  </div>
                </div>
                <p>{{ 'ADD_STUDENT.PART_B.INSTRUCTION_TEXT' | translate }}</p>

                <div *ngFor="let condition of specialNeedsConditions" class="mb-3 border-bottom pb-3">
                  <!-- <label class="form-label fw-bold">{{ condition.labelKey | translate }}</label> -->
                  <label class="form-label fw-bold d-flex align-items-center justify-content-between mb-2">
                    <span>{{ condition.labelKey | translate }}</span>
                    <svg *ngIf="formData[condition.severityNgModelName]"
                      (click)="clearSpecialNeedSelection(condition.severityNgModelName, condition.remarksNgModelName)"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      style="width: 1.2em; height: 1.2em; cursor: pointer; color: rgba(81, 42, 102, 0.9); flex-shrink: 0;"
                      title="{{ 'COMMON.CLEAR' | translate }}">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </label>
                  <div class="ps-md-2">
                    <div class="mb-2">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [id]="condition.id + 'Mild'"
                          [(ngModel)]="formData[condition.severityNgModelName]" [name]="condition.severityNgModelName"
                          value="Mild">
                        <label class="form-check-label" [for]="condition.id + 'Mild'">{{
                          'ADD_STUDENT.PART_B.SEVERITY_MILD'
                          | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [id]="condition.id + 'Moderate'"
                          [(ngModel)]="formData[condition.severityNgModelName]" [name]="condition.severityNgModelName"
                          value="Moderate">
                        <label class="form-check-label" [for]="condition.id + 'Moderate'">{{
                          'ADD_STUDENT.PART_B.SEVERITY_MODERATE' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [id]="condition.id + 'Severe'"
                          [(ngModel)]="formData[condition.severityNgModelName]" [name]="condition.severityNgModelName"
                          value="Severe">
                        <label class="form-check-label" [for]="condition.id + 'Severe'">{{
                          'ADD_STUDENT.PART_B.SEVERITY_SEVERE' | translate }}</label>
                      </div>
                    </div>
                    <div class="form-group mb-2">
                      <label [for]="condition.id + 'Remarks'" class="form-label form-label-sm">{{
                        'ADD_STUDENT.PART_B.REMARKS_LABEL' | translate }}</label>
                      <input type="text" class="form-control form-control-sm" [id]="condition.id + 'Remarks'"
                        [(ngModel)]="formData[condition.remarksNgModelName]" [name]="condition.remarksNgModelName">
                    </div>
                    <div *ngIf="condition.noteKey" class="form-text">
                      <small>{{ condition.noteKey | translate }}</small>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label fw-bold">{{ 'ADD_STUDENT.PART_B.OTHERS_LABEL' | translate }}</label>
                  <div class="ps-md-2">
                    <div class="form-group mb-2">
                      <label for="others" class="form-label form-label-sm">{{ 'ADD_STUDENT.PART_B.SPECIFY_LABEL'
                        |
                        translate }}</label>
                      <input type="text" class="form-control form-control-sm" id="others" ngModel name="others">
                    </div>
                  </div>
                </div>
                <p><b>{{ 'ADD_STUDENT.PART_B.MOBILITY_TITLE' | translate }}</b></p>

                <p><b>{{ 'ADD_STUDENT.PART_B.AMBULATORY_TITLE' | translate }}</b></p>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="ambulatoryIndependent" ngModel
                    name="ambulatoryIndependent">
                  <label class="form-check-label" for="ambulatoryIndependent">{{
                    'ADD_STUDENT.PART_B.AMBULATORY_INDEPENDENT'
                    | translate }}</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="ambulatoryAssistanceNeeded" ngModel
                    name="ambulatoryAssistanceNeeded">
                  <label class="form-check-label" for="ambulatoryAssistanceNeeded">{{
                    'ADD_STUDENT.PART_B.AMBULATORY_ASSISTANCE_NEEDED' | translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="ambulatoryUnaided" ngModel
                    name="ambulatoryUnaided">
                  <label class="form-check-label" for="ambulatoryUnaided">{{ 'ADD_STUDENT.PART_B.AMBULATORY_UNAIDED' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="ambulatoryCrutches" ngModel
                    name="ambulatoryCrutches">
                  <label class="form-check-label" for="ambulatoryCrutches">{{ 'ADD_STUDENT.PART_B.AMBULATORY_CRUTCHES' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="ambulatoryWalkingStick" ngModel
                    name="ambulatoryWalkingStick">
                  <label class="form-check-label" for="ambulatoryWalkingStick">{{
                    'ADD_STUDENT.PART_B.AMBULATORY_WALKING_STICK' | translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="checkbox" id="ambulatoryWalker" ngModel name="ambulatoryWalker">
                  <label class="form-check-label" for="ambulatoryWalker">{{ 'ADD_STUDENT.PART_B.AMBULATORY_WALKER' |
                    translate }}</label>
                </div>
                <div class="form-group mt-1"> <label for="ambulatory_other" class="form-label form-label-sm">{{
                    'ADD_STUDENT.PART_B.AMBULATORY_OTHER' | translate }}</label>
                  <input type="text" class="form-control form-control-sm" id="ambulatory_other" ngModel
                    name="ambulatory_other">
                </div>
                <!-- 从这开始单选 -->
                <hr class="mt-3">

                <label class="form-label fw-bold d-flex align-items-center justify-content-between mb-2">
                  <span><b>{{ 'ADD_STUDENT.PART_B.NON_AMBULATORY_SECTION_TITLE' | translate }}</b></span>
                  <svg *ngIf="studentProfileForm.value.nonAmbulatoryChoice" (click)="clearNonAmbulatorySelection()"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    style="width: 1.2em; height: 1.2em; cursor: pointer; color: rgba(81, 42, 102, 0.9); flex-shrink: 0;"
                    title="{{ 'COMMON.CLEAR' | translate }}">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </label>
                <div class="mb-2">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="nonAmbulatoryWheelchair" ngModel
                      name="nonAmbulatoryChoice" value="wheelchair_non_ambulatory">
                    <label class="form-check-label" for="nonAmbulatoryWheelchair">{{
                      'ADD_STUDENT.PART_B.NON_AMBULATORY_WHEELCHAIR' | translate }}</label>
                  </div>
                </div>
                <div class="mb-2">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="nonAmbulatoryWheelchairAssisted" ngModel
                      name="nonAmbulatoryChoice" value="wheelchair_ambulatory_with_assistance">
                    <label class="form-check-label" for="nonAmbulatoryWheelchairAssisted">{{
                      'ADD_STUDENT.PART_B.NON_AMBULATORY_WHEELCHAIR_ASSISTED' | translate }}</label>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="nonAmbulatoryOtherRadio" ngModel
                      name="nonAmbulatoryChoice" value="other">
                    <label class="form-check-label me-2" for="nonAmbulatoryOtherRadio">{{
                      'ADD_STUDENT.PART_B.NON_AMBULATORY_OTHER_CHECKBOX' | translate }}</label>
                  </div>

                  <input type="text" class="form-control form-control-sm mt-1" style="width: auto;"
                    id="non_ambulatory_other" ngModel name="non_ambulatory_other"
                    [disabled]="studentProfileForm.value.nonAmbulatoryChoice !== 'other'">
                  <div
                    *ngIf="studentProfileForm.controls['nonAmbulatoryChoice']?.errors?.['required'] && studentProfileForm.form.get('nonAmbulatoryChoice')?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.NON_AMBULATORY_CHOICE_REQUIRED' | translate }}
                  </div>
                </div>


                <hr class="mt-3">
                <label class="form-label fw-bold d-flex align-items-center justify-content-between mb-2">
                  <span><b>{{ 'ADD_STUDENT.PART_B.PARTS_AFFECTED_SECTION_TITLE' | translate }}</b></span>
                  <svg *ngIf="studentProfileForm.value.part_body_affected"
                    (click)="clearRadioSelection('part_body_affected')" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"
                    style="width: 1.2em; height: 1.2em; cursor: pointer; color: rgba(81, 42, 102, 0.9); flex-shrink: 0;"
                    title="{{ 'COMMON.CLEAR' | translate }}">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </label>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="partsAffectedRight" ngModel
                        name="part_body_affected" value="right">
                      <label class="form-check-label" for="partsAffectedRight">{{
                        'ADD_STUDENT.PART_B.PARTS_AFFECTED_RIGHT'
                        | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="partsAffectedLeft" ngModel
                        name="part_body_affected" value="left">
                      <label class="form-check-label" for="partsAffectedLeft">{{
                        'ADD_STUDENT.PART_B.PARTS_AFFECTED_LEFT' |
                        translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="partsAffectedUpperBody" ngModel
                        name="part_body_affected" value="upper_body">
                      <label class="form-check-label" for="partsAffectedUpperBody">{{
                        'ADD_STUDENT.PART_B.PARTS_AFFECTED_UPPER_BODY' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" id="partsAffectedLowerBody" ngModel
                        name="part_body_affected" value="lower_body">
                      <label class="form-check-label" for="partsAffectedLowerBody">{{
                        'ADD_STUDENT.PART_B.PARTS_AFFECTED_LOWER_BODY' | translate }}</label>
                    </div>
                  </div>
                  <div
                    *ngIf="studentProfileForm.controls['part_body_affected']?.errors?.['required'] && studentProfileForm.controls['part_body_affected']?.touched"
                    class="text-danger small mt-1">
                    {{ 'ADD_STUDENT.FORM_ERRORS.PART_BODY_AFFECTED_REQUIRED' | translate }}
                  </div>
                </div>

                <hr class="mt-3">
                <div class="mb-3">
                  <label for="prosthesis" class="form-label"><b>{{
                      'ADD_STUDENT.PART_B.PROSTHESIS_ORTHOSIS_LABEL' |
                      translate }}</b></label>
                  <input type="text" class="form-control" id="prosthesis" ngModel name="prosthesis">
                </div>

                <hr class="mt-3">
                <label class="form-label fw-bold d-flex align-items-center justify-content-between mb-2">
                  <span><b>{{ 'ADD_STUDENT.PART_B.HEAD_CONTROL_TITLE' | translate }}</b></span>
                  <svg *ngIf="studentProfileForm.value.head_control" (click)="clearRadioSelection('head_control')"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    style="width: 1.2em; height: 1.2em; cursor: pointer; color: rgba(81, 42, 102, 0.9); flex-shrink: 0;"
                    title="{{ 'COMMON.CLEAR' | translate }}">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="head_control" id="headControlGood" value="Good"
                    ngModel>
                  <label class="form-check-label" for="headControlGood">{{ 'ADD_STUDENT.PART_B.HEAD_CONTROL_GOOD' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="head_control" id="headControlFair" value="Fair"
                    ngModel>
                  <label class="form-check-label" for="headControlFair">{{ 'ADD_STUDENT.PART_B.HEAD_CONTROL_FAIR' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="head_control" id="headControlPoor" value="Poor"
                    ngModel>
                  <label class="form-check-label" for="headControlPoor">{{ 'ADD_STUDENT.PART_B.HEAD_CONTROL_POOR' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="head_control" id="headControlNoControl"
                    value="No control" ngModel>
                  <label class="form-check-label" for="headControlNoControl">{{
                    'ADD_STUDENT.PART_B.HEAD_CONTROL_NO_CONTROL'
                    | translate }}</label>
                </div>
                <div
                  *ngIf="studentProfileForm.controls['head_control']?.errors?.['required'] && studentProfileForm.controls['head_control']?.touched"
                  class="text-danger small mt-1">
                  {{ 'ADD_STUDENT.FORM_ERRORS.HEAD_CONTROL_REQUIRED' | translate }}
                </div>

                <hr class="mt-3">
                <label class="form-label fw-bold d-flex align-items-center justify-content-between mb-2">
                  <span><b>{{ 'ADD_STUDENT.PART_B.TRUNK_CONTROL_TITLE' | translate }}</b></span>
                  <svg *ngIf="studentProfileForm.value.trunk_control" (click)="clearRadioSelection('trunk_control')"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    style="width: 1.2em; height: 1.2em; cursor: pointer; color: rgba(81, 42, 102, 0.9); flex-shrink: 0;"
                    title="{{ 'COMMON.CLEAR' | translate }}">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </label>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="trunk_control" id="trunkControlGood" value="Good"
                    ngModel>
                  <label class="form-check-label" for="trunkControlGood">{{ 'ADD_STUDENT.PART_B.TRUNK_CONTROL_GOOD' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="trunk_control" id="trunkControlFair" value="Fair"
                    ngModel>
                  <label class="form-check-label" for="trunkControlFair">{{ 'ADD_STUDENT.PART_B.TRUNK_CONTROL_FAIR' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="trunk_control" id="trunkControlPoor" value="Poor"
                    ngModel>
                  <label class="form-check-label" for="trunkControlPoor">{{ 'ADD_STUDENT.PART_B.TRUNK_CONTROL_POOR' |
                    translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="trunk_control" id="trunkControlNoControl"
                    value="No control" ngModel>
                  <label class="form-check-label" for="trunkControlNoControl">{{
                    'ADD_STUDENT.PART_B.TRUNK_CONTROL_NO_CONTROL' | translate }}</label>
                </div>
                <div
                  *ngIf="studentProfileForm.controls['trunk_control']?.errors?.['required'] && studentProfileForm.controls['trunk_control']?.touched"
                  class="text-danger small mt-1">
                  {{ 'ADD_STUDENT.FORM_ERRORS.TRUNK_CONTROL_REQUIRED' | translate }}
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="accordion mb-3" id="guardianConsentAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingConsent">
              <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseConsent"
                aria-expanded="true" aria-controls="collapseConsent">
                {{ 'ADD_STUDENT.PART_C.GUARDIAN_CONSENT_TITLE' | translate }}
              </button>
            </h2>
            <div id="collapseConsent" class="accordion-collapse collapse show" aria-labelledby="headingConsent"
              data-bs-parent="#guardianConsentAccordion">
              <div class="accordion-body p-3">
                <p>{{ 'ADD_STUDENT.PART_C.INSTRUCTION_TEXT' | translate }}</p>
                <div *ngIf="hasConsentError && studentProfileForm.submitted" class="text-danger small mt-1">
                  {{ 'ADD_STUDENT.FORM_ERRORS.ALL_CONSENTS_REQUIRED' | translate }}
                </div>
                <hr>

                <div class="mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="riderInfoConsent" ngModel
                      name="riderInfoConsent" required>
                    <label class="form-check-label" for="riderInfoConsent">
                      <span class="text-danger">*</span>{{ consentLabels.fixedPrefix }} {{
                      consentLabels.riderInfoConsent }} </label>
                  </div>

                  <div class="ms-4 mt-1"> <a href="javascript:void(0);"
                      (click)="triggerDocumentDownload('health_assessment')"
                      *ngIf="getDocumentFileDetails('health_assessment').url && !isDownloadingDocument['health_assessment']"
                      class="small text-decoration-none"
                      title="{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}">
                      <i class="bi bi-download me-1"></i>-  {{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{
                      consentLabels.riderInfoConsent }}
                    </a>
                    <span *ngIf="isDownloadingDocument['health_assessment']" class="ms-2 small">
                      {{ 'GENERAL.LOADING' | translate }} <span class="spinner-border spinner-border-sm align-middle"
                        role="status"></span>
                    </span>
                    <div
                      *ngIf="documentDownloadError['health_assessment'] && !isDownloadingDocument['health_assessment']"
                      class="text-danger small mt-1">
                      {{ documentDownloadError['health_assessment'] }}
                    </div>
                  </div>
                </div>
                <hr>
                <!-- 
                <div class="mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="rehabReleaseConsent" ngModel
                      name="rehabReleaseConsent" required>
                    <label class="form-check-label" for="rehabReleaseConsent">
                      <span class="text-danger">*</span>{{ consentLabels.fixedPrefix }} {{
                      consentLabels.rehabReleaseConsent }} </label>
                  </div>
                  <div class="ms-4 mt-1"> <a href="javascript:void(0);"
                      (click)="triggerDocumentDownload('rehab_release_indemnity')"
                      *ngIf="getDocumentFileDetails('rehab_release_indemnity').url && !isDownloadingDocument['rehab_release_indemnity']"
                      class="small text-decoration-none"
                      title="{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}">
                      <i class="bi bi-download me-1"></i>-  {{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{
                      consentLabels.rehabReleaseConsent }}
                    </a>
                    <span *ngIf="isDownloadingDocument['rehab_release_indemnity']" class="ms-2 small">
                      {{ 'GENERAL.LOADING' | translate }} <span class="spinner-border spinner-border-sm align-middle"
                        role="status"></span>
                    </span>
                    <div
                      *ngIf="documentDownloadError['rehab_release_indemnity'] && !isDownloadingDocument['rehab_release_indemnity']"
                      class="text-danger small mt-1">
                      {{ documentDownloadError['rehab_release_indemnity'] }}
                    </div>
                  </div>
                </div>
                <hr> -->

                <div class="mb-1">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="photoVideoConsent" ngModel
                      name="photoVideoConsent">
                    <label class="form-check-label" for="photoVideoConsent">
                      {{ consentLabels.fixedPrefix }} {{ consentLabels.photoVideoConsent }} </label>
                  </div>
                </div>
                <div class="ms-4 mt-1"> <a href="javascript:void(0);"
                    (click)="triggerDocumentDownload('photo_taking_below_18')"
                    *ngIf="getDocumentFileDetails('photo_taking_below_18').url && !isDownloadingDocument['photo_taking_below_18']"
                    class="small text-decoration-none"
                    title="{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}">
                    <i class="bi bi-download me-1"></i>-  {{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{
                    consentLabels.nameBelow18 }}
                  </a>
                  <span *ngIf="isDownloadingDocument['photo_taking_below_18']" class="ms-2 small">
                    {{ 'GENERAL.LOADING' | translate }} <span class="spinner-border spinner-border-sm align-middle"
                      role="status"></span>
                  </span>
                  <div
                    *ngIf="documentDownloadError['photo_taking_below_18'] && !isDownloadingDocument['photo_taking_below_18']"
                    class="text-danger small mt-1">
                    {{ documentDownloadError['photo_taking_below_18'] }}
                  </div>
                </div>
                <div class="ms-4 mt-1"> <a href="javascript:void(0);"
                    (click)="triggerDocumentDownload('photo_taking_over_18')"
                    *ngIf="getDocumentFileDetails('photo_taking_over_18').url && !isDownloadingDocument['photo_taking_over_18']"
                    class="small text-decoration-none"
                    title="{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}">
                    <i class="bi bi-download me-1"></i>-  {{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{
                    consentLabels.nameOver18 }}
                  </a>
                  <span *ngIf="isDownloadingDocument['photo_taking_over_18']" class="ms-2 small">
                    {{ 'GENERAL.LOADING' | translate }} <span class="spinner-border spinner-border-sm align-middle"
                      role="status"></span>
                  </span>
                  <div
                    *ngIf="documentDownloadError['photo_taking_over_18'] && !isDownloadingDocument['photo_taking_over_18']"
                    class="text-danger small mt-1">
                    {{ documentDownloadError['photo_taking_over_18'] }}
                  </div>
                </div>
                <hr>
                <div class="mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="rdaLessonArrangementConsent" ngModel
                      name="rdaLessonArrangementConsent" required>
                    <label class="form-check-label" for="rdaLessonArrangementConsent">
                      <span class="text-danger">*</span>{{ consentLabels.fixedPrefix }} {{
                      consentLabels.rdaLessonArrangementConsent }} </label>
                  </div>
                  <div class="ms-4 mt-1 "> <a href="javascript:void(0);"
                      (click)="triggerDocumentDownload('rda_lesson_arrangement')"
                      *ngIf="getDocumentFileDetails('rda_lesson_arrangement').url && !isDownloadingDocument['rda_lesson_arrangement']"
                      class="small text-decoration-none"
                      title="{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }}">
                      <i class="bi bi-download me-1"></i>-  {{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{
                      consentLabels.rdaLessonArrangementConsent }}
                    </a>
                    <span *ngIf="isDownloadingDocument['rda_lesson_arrangement']" class="ms-2 small">
                      {{ 'GENERAL.LOADING' | translate }} <span class="spinner-border spinner-border-sm align-middle"
                        role="status"></span>
                    </span>
                    <div
                      *ngIf="documentDownloadError['rda_lesson_arrangement'] && !isDownloadingDocument['rda_lesson_arrangement']"
                      class="text-danger small mt-1">
                      {{ documentDownloadError['rda_lesson_arrangement'] }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="accordion mb-3" id="guardianDocumentAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingDocument">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseDocument" aria-expanded="true" aria-controls="collapseDocument">
                {{ 'ADD_STUDENT.PART_D.GUARDIAN_DOCUMENT_TITLE' | translate }}
              </button>
            </h2>
            <div id="collapseDocument" class="accordion-collapse collapse show" aria-labelledby="headingDocument"
              data-bs-parent="#guardianDocumentAccordion">
              <div class="accordion-body p-2">
                <p>{{ 'ADD_STUDENT.PART_D.INSTRUCTION_TEXT' | translate }} (<span
                    class="small text-muted">{{'ADD_STUDENT.PART_D.UPLOAD_FILE_REQUIREMENTS' | translate }}</span>)</p>
                <div *ngIf="isLoadingDocuments" class="text-center my-3">
                  <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                  <span class="ms-2">{{ 'GENERAL.LOADING' | translate }} Documents...</span>
                </div>
                <div *ngIf="documentsListError && !isLoadingDocuments" class="alert alert-warning small p-2 my-3">
                  {{ documentsListError }}
                </div>

                <div class="mb-3 row align-items-center">
                  <div class="col-md-6">
                    <label class="form-label">{{ consentLabels.medical_epilepsy }}</label>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <label for="statementEpilepsyUpload" class="btn btn-sm button-primary-greenish me-2">{{
                        'ADD_STUDENT.PART_D.UPLOAD_BUTTON_LABEL' | translate }}</label>
                      <input type="file" class="form-control form-control-sm d-none" id="statementEpilepsyUpload"
                        name="statementEpilepsy"
                        (change)="onDocumentFileSelected($event, 'statement_rider_medical_condition')"
                        #statementEpilepsyUpload>

                      <a href="javascript:void(0);" (click)="triggerDocumentDownload('medical_epilepsy')"
                        class="form-text text-muted me-2"
                        [class.disabled-link]="isDownloadingDocument['medical_epilepsy'] || !getDocumentFileDetails('medical_epilepsy').url"
                        [title]="getDocumentFileDetails('medical_epilepsy').url ? ('ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate) : null">
                        <span *ngIf="!isDownloadingDocument['medical_epilepsy']">{{
                          'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{ consentLabels.medical_epilepsy
                          }}</span>
                        <span *ngIf="isDownloadingDocument['medical_epilepsy']">
                          {{ 'GENERAL.LOADING' | translate }} <i class="bi bi-hourglass-split"></i>
                        </span>
                      </a>
                    </div>
                    <div *ngIf="formData['statement_rider_medical_condition']" class="form-text text-muted mt-1">{{
                      formData['statement_rider_medical_condition'] }}</div>
                    <div *ngIf="hasStatementEpilepsyError && studentProfileForm.submitted"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.STATEMENT_MEDICAL_EPILEPSY_REQUIRED' | translate }}
                    </div>
                    <div *ngIf="documentDownloadError['medical_epilepsy'] && !isDownloadingDocument['medical_epilepsy']"
                      class="text-danger small mt-1">
                      {{ documentDownloadError['medical_epilepsy'] }}
                    </div>
                  </div>
                </div>

                <div class="mb-3 row align-items-center">
                  <div class="col-md-6">
                    <label class="form-label">{{ consentLabels.medical_downs }}</label>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <label for="medicalDownSyndromeUpload" class="btn btn-sm button-primary-greenish me-2">{{
                        'ADD_STUDENT.PART_D.UPLOAD_BUTTON_LABEL' | translate }}</label>
                      <input type="file" class="form-control form-control-sm d-none" id="medicalDownSyndromeUpload"
                        name="medicalDownSyndrome"
                        (change)="onDocumentFileSelected($event, 'medical_certificate_down_syndrome')"
                        #medicalDownSyndromeUpload>

                      <a href="javascript:void(0);" (click)="triggerDocumentDownload('medical_downs')"
                        class="form-text text-muted me-2"
                        [class.disabled-link]="isDownloadingDocument['medical_downs'] || !getDocumentFileDetails('medical_downs').url"
                        [title]="getDocumentFileDetails('medical_downs').url ? ('ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate) : null">
                        <span *ngIf="!isDownloadingDocument['medical_downs']">{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT'
                          | translate }} {{ consentLabels.medical_downs }}</span>
                        <span *ngIf="isDownloadingDocument['medical_downs']">
                          {{ 'GENERAL.LOADING' | translate }} <i class="bi bi-hourglass-split"></i>
                        </span>
                      </a>
                    </div>
                    <div *ngIf="formData['medical_certificate_down_syndrome']" class="form-text text-muted mt-1">{{
                      formData['medical_certificate_down_syndrome'] }}</div>
                    <div *ngIf="hasMedicalDownSyndromeError && studentProfileForm.submitted"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.MEDICAL_CERTIFICATE_DOWN_SYNDROME_REQUIRED' | translate }}
                    </div>
                    <div *ngIf="documentDownloadError['medical_downs'] && !isDownloadingDocument['medical_downs']"
                      class="text-danger small mt-1">
                      {{ documentDownloadError['medical_downs'] }}
                    </div>
                  </div>
                </div>

                <div class="mb-3 row align-items-center">
                  <div class="col-md-6">
                    <label class="form-label">{{ consentLabels.medical_heart_ }}</label>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <label for="medicalHeartDiseaseUpload" class="btn btn-sm button-primary-greenish me-2">{{
                        'ADD_STUDENT.PART_D.UPLOAD_BUTTON_LABEL' | translate }}</label>
                      <input type="file" class="form-control form-control-sm d-none" id="medicalHeartDiseaseUpload"
                        name="medicalHeartDisease"
                        (change)="onDocumentFileSelected($event, 'medical_certificate_heart_disease')"
                        #medicalHeartDiseaseUpload>

                      <a href="javascript:void(0);" (click)="triggerDocumentDownload('medical_heart_')"
                        class="form-text text-muted me-2"
                        [class.disabled-link]="isDownloadingDocument['medical_heart_'] || !getDocumentFileDetails('medical_heart_').url"
                        [title]="getDocumentFileDetails('medical_heart_').url ? ('ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate) : null">
                        <span *ngIf="!isDownloadingDocument['medical_heart_']">{{
                          'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{ consentLabels.medical_heart_
                          }}</span>
                        <span *ngIf="isDownloadingDocument['medical_heart_']">
                          {{ 'GENERAL.LOADING' | translate }} <i class="bi bi-hourglass-split"></i>
                        </span>
                      </a>
                    </div>
                    <div *ngIf="formData['medical_certificate_heart_disease']" class="form-text text-muted mt-1">{{
                      formData['medical_certificate_heart_disease'] }}</div>
                    <div *ngIf="hasMedicalHeartDiseaseError && studentProfileForm.submitted"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.MEDICAL_CERTIFICATE_HEART_DISEASE_REQUIRED' | translate }}
                    </div>
                    <div *ngIf="documentDownloadError['medical_heart_'] && !isDownloadingDocument['medical_heart_']"
                      class="text-danger small mt-1">
                      {{ documentDownloadError['medical_heart_'] }}
                    </div>
                  </div>
                </div>
                <div class="mb-3 row align-items-center">
                  <div class="col-md-6">
                    <label class="form-label"><span class="text-danger">*</span>{{ consentLabels.rehabReleaseConsent
                      }}</label>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <label for="statementReleaseIndemnityUpload" class="btn btn-sm button-primary-greenish me-2">{{
                        'ADD_STUDENT.PART_D.UPLOAD_BUTTON_LABEL' | translate }}</label>
                      <input type="file" class="d-none" id="statementReleaseIndemnityUpload"
                        name="statementReleaseIndemnity"
                        (change)="onDocumentFileSelected($event, 'statement_release_indemnity')"
                        accept=".pdf,.doc,.docx,.jpeg,.png,.jpg">
                      <a href="javascript:void(0);" (click)="triggerDocumentDownload('rehab_release_indemnity')"
                        class="form-text text-muted me-2">
                        <span>{{ 'ADD_STUDENT.PART_D.DOWNLOAD_LINK_TEXT' | translate }} {{
                          consentLabels.rehabReleaseConsent }}</span>
                      </a>
                    </div>
                    <div *ngIf="formData['statement_release_indemnity']" class="form-text text-muted mt-1">{{
                      formData['statement_release_indemnity'] }}</div>

                    <div *ngIf="hasStatementReleaseIndemnityError && studentProfileForm.submitted"
                      class="text-danger small mt-1">
                      {{ 'ADD_STUDENT.FORM_ERRORS.STATEMENT_RELEASE_INDEMNITY_REQUIRED' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
      <div class="button-container">
        <button type="submit" class="btn button-primary-purple me-2" form="studentDataForm" [disabled]="isSubmitting">
          {{ 'ADD_STUDENT.SUBMIT_BUTTON' | translate }}
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2" role="status"
            aria-hidden="true"></span>
        </button>
        <button type="button" class="btn btn-outline-secondary" routerLink="/student-profile-summary">{{
          'ADD_STUDENT.CANCEL_BUTTON' |
          translate
          }}</button>
      </div>
      <div style="height: 100px;"></div>
    </div>

    <app-student-profile-preview-modal [isVisible]="isPreviewModalVisible" [previewData]="previewData"
      (confirm)="handleFinalSubmit()" (close)="handleCloseModal()">
    </app-student-profile-preview-modal>

  </div>
</div>